export function isEmbed(work){
	if (work.type == 'soundcloud'){
		return true;
	}
	return false;
}